if (!customElements.get('collapsible-text')) {
  customElements.define(
    'collapsible-text',
    class CollapsibleText extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.collection-description-bottom__content');
        this.toggle = this.querySelector('.collection-description-bottom__toggle');
        if (!this.content || !this.toggle) return;

        this.classList.add('is-collapsed');
        if (this.content.scrollHeight - this.content.clientHeight < 48) {
          this.classList.remove('is-collapsed');
          return;
        }

        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => this.setExpanded(this.classList.contains('is-collapsed')));
      }

      setExpanded(expanded) {
        this.classList.toggle('is-collapsed', !expanded);
        this.toggle.setAttribute('aria-expanded', String(expanded));
        this.toggle.textContent = expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
      }
    }
  );
}
